type ImageInfo = {
  cover_type: string;
  cover_pixel: number | string;
  cover_time: string;
}

function getImageFormat(url) {
  // 提取图片格式
  const extension = url.split('.').pop()?.split('?').shift()?.toUpperCase()
  return extension === 'JPG' ? 'JPEG' : extension
}


function getImageInfo(url: string): Promise<ImageInfo> {
  return new Promise((resolve, reject) => {
    const image = new Image()
    let info: ImageInfo = {
      cover_type: '',
      cover_pixel: '',
      cover_time: ''
    }
    if (!url) {
      resolve(info)
      return
    }

    const reset = (marks: string[] = [], measures: string[] = []) => {
      marks.forEach(m => performance.clearMarks(m))
      measures.forEach(m => performance.clearMeasures(m))
    }

    image.onload = async function() {
      // Set a performance mark for the end of image loading
      performance.mark('imageLoadEnd')

      // Measure the loading time
      performance.measure('imageLoaded', 'imageLoadStart', 'imageLoadEnd')
      const loadingTime = performance.getEntriesByName('imageLoaded')[0].duration

      info = {
        cover_type: getImageFormat(image.src),
        cover_pixel: `${image.naturalWidth}x${image.naturalHeight}`,
        cover_time: loadingTime.toFixed(2)
      }

      resolve(info)
      reset(['imageLoadStart', 'imageLoadEnd'], ['imageLoaded'])
    }

    image.onerror = function() {
      reject(info)
      reset(['imageLoadStart', 'imageLoadEnd'], ['imageLoaded'])
    }

    image.src = url

    // Set a performance mark for the start of image loading
    performance.mark('imageLoadStart')
  })
   
}


export {
  getImageInfo
}